
import BannerLoader from './banner-loader.vue'

export default {
    name: 'ImageCard',
    components: {
        BannerLoader,
    },
    props: ['imgSrc'],
    data() {
        return {
            loading: true,
        }
    },
    methods: {
        imageLoaded() {
            this.loading = false
            this.$emit('image-loaded')
        },
    },
}
